import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TemplateService, Template } from '../../services/template.service';

@Component({
  selector: 'app-share-interview-link',
  templateUrl: './share-interview-link.component.html',
  styleUrl: './share-interview-link.component.scss'
})
export class ShareInterviewLinkComponent implements OnInit {
  templateId: string = '';
  interviewDetails?: Template;
  copied = false;
  windowOrigin = window.location.origin;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private templateService: TemplateService
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.templateId = params.get('id') || '';
      if (this.templateId) {
        this.templateService.getTemplateById(this.templateId).subscribe(
          (data) => this.interviewDetails = data,
          (err) => this.interviewDetails = undefined
        );
      }
    });
  }

  continueToInterview(): void {
    if (this.templateId) {
      this.router.navigate(['/chat'], { queryParams: { templateId: this.templateId } });
    }
  }

  copyLink() {
    const link = `${this.windowOrigin}/chat/interview/${this.templateId}`;
    this.copyTextToClipboard(link, () => {
      this.copied = true;
      setTimeout(() => (this.copied = false), 2000);
    });
  }

  /**
   * Robust clipboard copy with fallback for iframe and browser limitations
   */
  copyTextToClipboard(text: string, onSuccess?: () => void, onError?: (err: any) => void) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text)
        .then(() => onSuccess && onSuccess())
        .catch(err => {
          this.fallbackCopyTextToClipboard(text, onSuccess, onError);
        });
    } else {
      this.fallbackCopyTextToClipboard(text, onSuccess, onError);
    }
  }

  fallbackCopyTextToClipboard(text: string, onSuccess?: () => void, onError?: (err: any) => void) {
    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.style.position = 'fixed';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      const successful = document.execCommand('copy');
      document.body.removeChild(textarea);
      if (successful) {
        onSuccess && onSuccess();
      } else {
        onError && onError('execCommand failed');
      }
    } catch (err) {
      onError && onError(err);
    }
  }
}
